
import './index.less'
import HocDragAndDrop from '../../Hoc/DragAndDrop/index.jsx'
import HocCalculateDistance from '../../Hoc/CalculateDistance'
import { useEffect, useState } from 'react'
import SetColor from '../setColor/index.jsx'
import React from 'react'

export default function CompMain(props) {
  return (<div className='compMain'>
    <ul className='compMain_box'>
      {props.components.map((item, index) => {
        return (<li className='box_item' key={item.id}>
          <div className='item_left'>
            <div className='left_tint'>
              <SetColor color={item.back} setColor={(colorObj) => {
                props.components[index].back = colorObj.hex
                props.setBack && props.setBack(props.components)
              }}></SetColor>
              <span className='tint_text'>背景</span>
            </div>
            {index !== 0 && <div className='left_delete' onClick={() => {
              props.deleteFlipping(index)
            }}>
              <i className='delete_icon'><svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='delete'><path d='M14 5V15C14 15.5523 13.5523 16 13 16H5C4.44772 16 4 15.5523 4 15V5H2.5C2.22386 5 2 4.77614 2 4.5V4C2 3.72386 2.22386 3.5 2.5 3.5H6V2.5C6 2.22386 6.22386 2 6.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5H15.5C15.7761 3.5 16 3.72386 16 4V4.5C16 4.77614 15.7761 5 15.5 5H14ZM6.75 6.5V13H8.25V6.5H6.75ZM9.75 6.5V13H11.25V6.5H9.75Z' fill-rule='evenodd'></path></svg></i>
            </div>}

          </div>
          <Comps
            compIfon={item}
            pressItem={props.pressItem}
            pressAndHold={props.pressAndHold}
            move={props.move}
            up={props.up}
            selectItem={props.selectItem}
            deleteItem={props.deleteItem}
            hoistPopup={props.hoistPopup}
          ></Comps>
        </li>)
      })}
    </ul>

    <div className='compMain_buttonArea'>
      <button className='compMain_button' onClick={props.addFlipping}>
        <i className='button_icon'><svg width='16' height='16' style={{ marginRight: '12px' }}><g fill='none' fill-rule='nonzero'><path d='M.912 9.745A.75.75 0 0 1 1 8.25c.447 0 1.874 1.009 7.019 4.822l6.545-4.682a.75.75 0 1 1 .872 1.22l-7.433 5.318-.439-.326a370.123 370.123 0 0 0-5.112-3.741c-.578-.412-1.021-.72-1.327-.923a7.27 7.27 0 0 0-.332-.21c.032.018.039.022.073.023l.046-.006zm-.046.006L1 9.75a.758.758 0 0 1-.088-.005l-.046.006z' fill='#A3A3A3'></path><path d='M.912 4.745A.75.75 0 0 1 1 3.25c.447 0 1.874 1.009 7.019 4.822l6.545-4.682a.75.75 0 1 1 .872 1.22L8.003 9.928l-.439-.326a370.123 370.123 0 0 0-5.112-3.741c-.578-.412-1.021-.72-1.327-.923a7.242 7.242 0 0 0-.333-.211c.033.019.04.023.074.024l.046-.006zm-.046.006L1 4.75a.758.758 0 0 1-.088-.005l-.046.006z' fill='#D6D6D6'></path></g></svg></i>
        <span className='button_text'>添加翻页效果</span>
      </button>
    </div>

  </div>)
}

function Comps(props) {
  const [ifon] = useState({
    compBox: React.createRef(),
    content: React.createRef()
  })

  useEffect(() => {
    props.compIfon.compBox = ifon.compBox.current
    props.compIfon.content = ifon.content.current
  }, [])

  return (<div className='Comps'>
    <div className='Comps_left'></div>
    <div className='Comps_main' style={{
      paddingBottom: props.compIfon.comps.filter((item) => {
        return item.name === 'marketing_suspension_comp'
      }).length ? '88px' : '0px',
      backgroundColor: props.compIfon.back
    }} ref={ifon.compBox}>
      <div className='conCopm' ref={ifon.content}>
        {props.compIfon.comps.map((item, index) => {
          if (item.name === 'Tips1') {
            return <HocCalculateDistance
              compIfon={item}
              key={item.id}
              isSide={false}
              selectItem={props.selectItem}
            ><item.comp pressItem={props.pressItem} selectItem={props.selectItem}></item.comp></HocCalculateDistance>
          } else {
            return <HocCalculateDistance
              compIfon={item}
              key={item.id}
              isSide={true}
              deleteItem={props.deleteItem}
              selectItem={props.selectItem}
            ><HocDragAndDrop pressAndHold={props.pressAndHold} move={props.move} up={props.up} copyComp={item.copyComp} ifon={item} isCut={true}><item.comp ifon={item.ifon} selectItem={props.selectItem} compIfon={item} hoistPopup={props.hoistPopup}></item.comp></HocDragAndDrop></HocCalculateDistance>
          }
        })}
      </div>

    </div>
  </div>)
}
